var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-wrapper" }, [
    _c("div", { staticClass: "chat-sidebar" }, [
      _c("div", { staticClass: "chat-sidebar-body" }, [
        _c(
          "div",
          { staticClass: "flex-fill pd-y-20 pd-x-10" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "b-menu",
              [
                _c(
                  "b-menu-list",
                  _vm._l(_vm.chg_dept_a, function(form) {
                    return _c(
                      "b-menu-item",
                      {
                        key: form.id,
                        staticClass:
                          "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                        attrs: {
                          expanded: true,
                          label: form.kor,
                          id: form.id,
                          icon: "home"
                        }
                      },
                      [
                        _vm._l(_vm.user_a, function(user) {
                          return user.team[0] === form.id
                            ? _c("b-menu-item", {
                                key: user.id,
                                staticClass:
                                  "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                attrs: { id: user.id, icon: "account" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "b-dropdown",
                                            { attrs: { "aria-role": "list" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "trigger" },
                                                  slot: "trigger"
                                                },
                                                [
                                                  _vm._v(_vm._s(user.userName)),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tx-10 tx-color-03"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "  " +
                                                          _vm._s(
                                                            user.position
                                                              .codeName
                                                          ) +
                                                          "[" +
                                                          _vm._s(
                                                            user.official
                                                              .codeName
                                                          ) +
                                                          "]"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-dropdown-item",
                                                {
                                                  staticClass: "tx-10",
                                                  attrs: {
                                                    "aria-role": "listitem"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addReview(
                                                        user.id,
                                                        form.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Review")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-dropdown-item",
                                                {
                                                  staticClass: "tx-10",
                                                  attrs: {
                                                    "aria-role": "listitem"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addApproval(
                                                        user.id,
                                                        form.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Approval")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm._l(form.child, function(form1) {
                          return form.child.length > 0
                            ? _c(
                                "b-menu-item",
                                {
                                  key: form1.id,
                                  staticClass:
                                    "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                  attrs: {
                                    label: form1.kor,
                                    icon: "view-sequential"
                                  }
                                },
                                [
                                  _vm._l(_vm.user_a, function(user) {
                                    return user.team[0] === form1.id
                                      ? _c("b-menu-item", {
                                          key: user.id,
                                          staticClass:
                                            "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                          attrs: {
                                            id: user.id,
                                            icon: "account"
                                          },
                                          on: { click: function($event) {} },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "b-dropdown",
                                                      {
                                                        attrs: {
                                                          "aria-role": "list"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "trigger"
                                                            },
                                                            slot: "trigger"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                user.userName
                                                              )
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tx-10 tx-color-03"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "  " +
                                                                    _vm._s(
                                                                      user
                                                                        .position
                                                                        .codeName
                                                                    ) +
                                                                    "[" +
                                                                    _vm._s(
                                                                      user
                                                                        .official
                                                                        .codeName
                                                                    ) +
                                                                    "]"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            staticClass:
                                                              "tx-10",
                                                            attrs: {
                                                              "aria-role":
                                                                "listitem"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addReview(
                                                                  user.id,
                                                                  form1.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Review")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-dropdown-item",
                                                          {
                                                            staticClass:
                                                              "tx-10",
                                                            attrs: {
                                                              "aria-role":
                                                                "listitem"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addApproval(
                                                                  user.id,
                                                                  form1.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Approval")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  _vm._l(form1.child, function(form2) {
                                    return form1.child.length > 0
                                      ? _c(
                                          "b-menu-item",
                                          {
                                            key: form2.id,
                                            staticClass:
                                              "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                            attrs: {
                                              label: form2.kor,
                                              icon: "view-sequential"
                                            }
                                          },
                                          [
                                            _vm._l(_vm.user_a, function(user) {
                                              return user.team[0] === form2.id
                                                ? _c("b-menu-item", {
                                                    key: user.id,
                                                    staticClass:
                                                      "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                                    attrs: {
                                                      id: user.id,
                                                      icon: "account"
                                                    },
                                                    on: {
                                                      click: function($event) {}
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function(props) {
                                                            return [
                                                              _c(
                                                                "b-dropdown",
                                                                {
                                                                  attrs: {
                                                                    "aria-role":
                                                                      "list"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        slot:
                                                                          "trigger"
                                                                      },
                                                                      slot:
                                                                        "trigger"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          user.userName
                                                                        )
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "tx-10 tx-color-03"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "  " +
                                                                              _vm._s(
                                                                                user
                                                                                  .position
                                                                                  .codeName
                                                                              ) +
                                                                              "[" +
                                                                              _vm._s(
                                                                                user
                                                                                  .official
                                                                                  .codeName
                                                                              ) +
                                                                              "]"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      staticClass:
                                                                        "tx-10",
                                                                      attrs: {
                                                                        "aria-role":
                                                                          "listitem"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.addReview(
                                                                            user.id,
                                                                            form2.id
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Review"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      staticClass:
                                                                        "tx-10",
                                                                      attrs: {
                                                                        "aria-role":
                                                                          "listitem"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.addApproval(
                                                                            user.id,
                                                                            form2.id
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Approval"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                : _vm._e()
                                            }),
                                            _vm._v(" "),
                                            _vm._l(form2.child, function(
                                              form3
                                            ) {
                                              return form2.child.length > 0
                                                ? _c(
                                                    "b-menu-item",
                                                    {
                                                      key: form3.id,
                                                      staticClass:
                                                        "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                                      attrs: {
                                                        label: form3.kor,
                                                        icon: "view-sequential"
                                                      }
                                                    },
                                                    _vm._l(_vm.user_a, function(
                                                      user
                                                    ) {
                                                      return user.team[0] ===
                                                        form3.id
                                                        ? _c("b-menu-item", {
                                                            key: user.id,
                                                            staticClass:
                                                              "tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1",
                                                            attrs: {
                                                              id: user.id,
                                                              icon: "account"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {}
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function(
                                                                    props
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "b-dropdown",
                                                                        {
                                                                          attrs: {
                                                                            "aria-role":
                                                                              "list"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              attrs: {
                                                                                slot:
                                                                                  "trigger"
                                                                              },
                                                                              slot:
                                                                                "trigger"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  user.userName
                                                                                )
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "tx-10 tx-color-03"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "  " +
                                                                                      _vm._s(
                                                                                        user
                                                                                          .position
                                                                                          .codeName
                                                                                      ) +
                                                                                      "[" +
                                                                                      _vm._s(
                                                                                        user
                                                                                          .official
                                                                                          .codeName
                                                                                      ) +
                                                                                      "]"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "b-dropdown-item",
                                                                            {
                                                                              staticClass:
                                                                                "tx-10",
                                                                              attrs: {
                                                                                "aria-role":
                                                                                  "listitem"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.addReview(
                                                                                    user.id,
                                                                                    form3.id
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Review"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "b-dropdown-item",
                                                                            {
                                                                              staticClass:
                                                                                "tx-10",
                                                                              attrs: {
                                                                                "aria-role":
                                                                                  "listitem"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.addApproval(
                                                                                    user.id,
                                                                                    form3.id
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Approval"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          })
                                                        : _vm._e()
                                                    }),
                                                    1
                                                  )
                                                : _vm._e()
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chat-content" }, [
      _c(
        "div",
        { staticClass: "chat-content-body t-0" },
        [
          _c(
            "div",
            { staticClass: "col-xl-3-1 mg-t-10 pr-0 pl-0 float-left" },
            [
              _c("div", { staticClass: "card card-profile" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body tx-13" }, [
                  _c("div", { staticClass: "mt-0" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.request_user.userName))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.request_user.teamName))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.request_user.position.codeName))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block a-btn-border",
                        attrs: { disabled: "" }
                      },
                      [_vm._v("Request")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 pd-b-2-f" }, [
                      _vm._v("2019-12-18")
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.reivew_a, function(form) {
            return _c(
              "div",
              { staticClass: "col-xl-3-1 mg-t-10 pr-0 pl-0 float-left" },
              [
                _c("div", { staticClass: "card card-profile" }, [
                  _vm._m(2, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body tx-13" }, [
                    _c("div", { staticClass: "mt-0" }, [
                      _c("h5", [_vm._v(_vm._s(form.userName) + " ")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(form.deptkor) + " ")
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(form.positionName) + " ")]),
                      _vm._v(" "),
                      form.apprid.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-white",
                              on: {
                                click: function($event) {
                                  return _vm.confirmApproval(
                                    form.userid,
                                    form.apprid,
                                    form.gid
                                  )
                                }
                              }
                            },
                            [_vm._v("Approval ")]
                          )
                        : form.userid.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-white",
                              on: {
                                click: function($event) {
                                  return _vm.delApproval(
                                    form.userid,
                                    form.apprid,
                                    form.gid,
                                    "R"
                                  )
                                }
                              }
                            },
                            [_vm._v("Cancel ")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-block a-btn-border",
                              attrs: { disabled: "" }
                            },
                            [_vm._v(_vm._s(form.apprid) + " ")]
                          ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0 pd-b-2-f" }, [
                        _vm._v(_vm._s(form.apprdate) + " ")
                      ])
                    ])
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.approval_a, function(form) {
            return _c(
              "div",
              { staticClass: "col-xl-3-1 mg-t-10 pr-0 pl-0 float-left" },
              [
                _c("div", { staticClass: "card card-profile" }, [
                  _vm._m(3, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body tx-13" }, [
                    _c("div", { staticClass: "mt-0" }, [
                      _c("h5", [_vm._v(_vm._s(form.userName) + " ")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(form.deptkor) + " ")
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(form.positionName) + " ")]),
                      _vm._v(" "),
                      form.apprid.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-white",
                              on: {
                                click: function($event) {
                                  return _vm.confirmApproval(
                                    form.userid,
                                    form.apprid,
                                    form.gid
                                  )
                                }
                              }
                            },
                            [_vm._v("Approval ")]
                          )
                        : form.userid.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-block btn-white",
                              on: {
                                click: function($event) {
                                  return _vm.delApproval(
                                    form.userid,
                                    form.apprid,
                                    form.gid,
                                    "A"
                                  )
                                }
                              }
                            },
                            [_vm._v("Cancel ")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-block a-btn-border",
                              attrs: { disabled: "" }
                            },
                            [_vm._v(_vm._s(form.apprid) + " ")]
                          ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0 pd-b-2-f" }, [
                        _vm._v(_vm._s(form.apprdate) + " ")
                      ])
                    ])
                  ])
                ])
              ]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-between pd-x-10 mg-b-10"
      },
      [
        _c(
          "span",
          {
            staticClass:
              "tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1"
          },
          [_vm._v("Department")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body tx-13 pd-0-f app-top-radius" }, [
      _c("div", { staticClass: "mt-0" }, [
        _c("h6", { staticClass: "mt-2 text-uppercase" }, [_vm._v("request")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body tx-13 pd-0-f app-top-radius" }, [
      _c("div", { staticClass: "mt-0" }, [
        _c("h6", { staticClass: "mt-2 text-uppercase" }, [_vm._v("review")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body tx-13 pd-0-f app-top-radius" }, [
      _c("div", { staticClass: "mt-0" }, [
        _c("h6", { staticClass: "mt-2 text-uppercase" }, [_vm._v("approval")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d501186", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d501186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/Approval.vue
// module id = null
// module chunks = 